import { CoreModalDialog } from '@components'
import { tr, useGlobalMaintenanceMode } from 'mmfintech-commons'

import './maintenanceModal.scss'

export const MaintenanceModal = () => {
  const isMaintenanceMode = useGlobalMaintenanceMode()

  return isMaintenanceMode ? (
    <CoreModalDialog
      visible={true}
      onClose={() => {}}
      header={tr('FRONTEND.MAINTENANCE.TITLE', 'Scheduled Maintenance')}
      content={
        <div className='maintenance-modal-content'>
          <p>
            {tr(
              'FRONTEND.MAINTENANCE.BODY',
              'We are currently performing scheduled maintenance. Please check back shortly. We apologize for any inconvenience.'
            )}
          </p>
        </div>
      }
      options={{
        hideCloseIcon: true,
        closeOnClickOutside: false,
        closeOnEscape: false,
        size: 'auto'
      }}
    />
  ) : null
}
